import axios from 'axios'
import { ref } from 'vue'
import { store } from '../store/index'
import { clearToken } from '@/utils/useToken'
import { useAlert } from '@/modules/composition/useAlert'

// Создаем экземпляр axios с настройками
const api = axios.create({
	baseURL: window.location.origin + '/api'
})
// Устанавливаем заголовок для авторизации по Basic Auth
const authString = window.localStorage.getItem('access_token')
api.defaults.headers.common.Authorization = authString

const { errorAlert } = useAlert()

// Перехватываем ошибки ответа от сервера
api.interceptors.response.use(
	(response) => response,
	(error) => {
		switch (error.response.status) {
		case 500:
			if (error.value?.message) {
				errorAlert(error.value?.message)
				return Promise.resolve(error)
			}
			errorAlert('Ошибка сервера')
			return Promise.resolve(error)
		default:
			console.log(error)
			if (!axios.isCancel(error)) {
				if (error.value?.message) {
					errorAlert(error.value?.message)
					return Promise.resolve(error)
				}

				console.error('response error:' + error)
			}
			return Promise.reject(error)
		}
	}
)
// Экспортируем функцию, которая возвращает API-интерфейс
export const useApi = (endpoint) => {
	const data = ref(null)
	const error = ref(null)

	api.defaults.headers.common.Authorization = authString

	/**
	 * Выполняет GET-запрос к заданному URL.
	 *
	 * @param {string} [query] - доп. параметры в строке запроса
	 * @param {object} config - конфигурация запроса (например, headers)
	 */
	const get = async (query, config) => {
		store.commit('setLoading', true)

		try {
			const res = await api.get(`${endpoint}${typeof query !== 'undefined' ? query : ''}`, config)
			data.value = res.data
		} catch (e) {
			console.log('error:', e.request)
			if (e.request.status === 401) {
				await clearToken()
				document.location.href = '/' // Перенаправляем на страницу авторизации при получении статуса 401
			} else error.value = e.response?.data
		} finally {
			store.commit('setLoading', false)
		}
	}

	/**
	 * Выполняет POST-запрос к заданному URL.
	 *
	 * @param {object} payload - тело запроса
	 */
	const post = async (payload = {}) => {
		store.commit('setLoading', true)

		try {
			const res = await api.post(endpoint, payload)
			data.value = res.data
		} catch (e) {
			if (e.request.status === 401) {
				await clearToken()
				document.location.href = '/' // Перенаправляем на страницу авторизации при получении статуса 401
			} else error.value = e.response?.data
		} finally {
			store.commit('setLoading', false)
		}
	}

	/**
	 * Выполняет DELETE-запрос к заданному URL.
	 *
	 * @param {string} [query] - доп. параметры в строке запроса
	 * @param {object} data - тело запроса
	 */
	const del = async (query, data) => {
		await store.commit('setLoading', true)

		const config = data ? { data } : undefined

		try {
			const res = await api.delete(`${endpoint}${query || ''}`, config)
			if (data !== undefined) data.value = res.data
		} catch (e) {
			if (e.request.status === 401) {
				await clearToken()
				document.location.href = '/' // Перенаправляем на страницу авторизации при получении статуса 401
			} else error.value = e.response?.data
		} finally {
			store.commit('setLoading', false)
		}
	}
	return {
		data,
		error,
		get,
		post,
		del
	}
}
